
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Typography,
  Box
} from '@mui/material';
import { toast } from 'react-toastify';
import Package from '../../models/package';

const EditPackage = ({ setPageTitle }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    status: 'ACTIVE',
    amount: '',
    limit_delivery: '',
    price: '',
    interval: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setPageTitle("Chỉnh sửa gói dịch vụ");
    console.log(id)
    if (id) {
      fetchPackageData();
    }
  }, [id, setPageTitle]);

  const fetchPackageData = async () => {
    console.log('fetch')
    try {
      const packageModel = new Package();
      const data = await packageModel.getPackageById(id);
      if (data) {
        setFormData({
          name: data.name,
          status: data.status,
          amount: data.amount,
          limit_delivery: data.limit_delivery,
          price: data.price,
          interval: data.interval
        });
      }
    } catch (error) {
      toast.error('Không thể tải thông tin gói dịch vụ');
      navigate('/packages');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const packageModel = new Package(formData);
    try {
      const response = await packageModel.updatePackage(id);
      if (response && response.success) {
        toast.success(response.message);
        navigate('/packages');
      } else {
        toast.error('Cập nhật gói dịch vụ thất bại');
      }
    } catch (error) {
      toast.error('Đã xảy ra lỗi khi cập nhật gói dịch vụ');
    }
  };

  if (loading) {
    return <div>Đang tải...</div>;
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h6" gutterBottom>
          Chỉnh sửa gói dịch vụ
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Tên gói"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Trạng thái</InputLabel>
                <Select
                  name="status"
                  value={formData.status}
                  label="Trạng thái"
                  onChange={handleChange}
                >
                  <MenuItem value="ACTIVE">Hoạt động</MenuItem>
                  <MenuItem value="INACTIVE">Không hoạt động</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                type="number"
                label="Số lượng"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                type="number"
                label="Giới hạn giao hàng"
                name="limit_delivery"
                value={formData.limit_delivery}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                type="number"
                label="Giá"
                name="price"
                value={formData.price}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                type="number"
                label="Khoảng thời gian (ngày)"
                name="interval"
                value={formData.interval}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/packages')}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
            >
              Lưu thay đổi
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default EditPackage;
